import { useStaticQuery, graphql } from 'gatsby'
import {
  parseHtmlToReact,
  prepareForParse,
  getContentfulDefaultLocaleCode,
  getContentfulSecondLocaleCode,
} from '../../utils'

// page、informationDetail で生成するページに対応
// 利用用途のない campusnewsDetail、diseaseDetail には対応していない
const CustomLocaleToggleButton = ({ data: { pageContext, ...pageData } }) => {
  const {
    locales,
    locale,
    slug = null,
    // path には locale を含まない
    pagePath = null,
  } = pageContext

  // 言語切替ボタン制御
  const defaultLocaleCode = getContentfulDefaultLocaleCode(locales)
  const secondLocaleCode = getContentfulSecondLocaleCode(locales)
  const toggledLocaleCode =
    locale !== defaultLocaleCode ? defaultLocaleCode : secondLocaleCode
  const toggledLocalePath =
    toggledLocaleCode === defaultLocaleCode ? '' : `/${toggledLocaleCode}`
  // page.js 経由で呼ばれた場合
  const toggledLocalePage =
    pageData.customAllContentfulPage?.nodes.find(
      (node) =>
        node.pagePath === pagePath && node.node_locale === toggledLocaleCode
    ) ?? {}
  // informationDetail.js 経由で呼ばれた場合
  const toggledLocaleInformation =
    pageData.customAllContentfulInformation?.nodes.find(
      (node) => node.slug === slug && node.node_locale === toggledLocaleCode
    ) ?? {}

  // トグル先ページのパス
  const toggledPagePath = `${toggledLocalePath}${pagePath}`

  // Template 取得
  // 本来であれば variables で絞り込みたいが、制約がありできない
  // https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/#known-limitations
  const data = useStaticQuery(graphql`
    query {
      allContentfulTemplate(
        filter: { name: { eq: "customLocaleToggleButton" } }
      ) {
        nodes {
          contentful_id
          __typename
          node_locale
          name
          body {
            raw
          }
        }
      }
    }
  `)
  const template = data.allContentfulTemplate.nodes.find(
    (node) => node.node_locale === locale
  )
  if (template === undefined) {
    throw new Error(`Template not found: ${locale}`)
  }

  const { htmlBody, componentData } = prepareForParse({
    template,
    data: {
      ...pageData,
      context: { path: toggledPagePath },
    },
    pageContext,
  })

  return toggledLocalePage.body?.raw != null ||
    toggledLocaleInformation.body?.childMarkdownRemark?.html != null
    ? parseHtmlToReact(htmlBody, componentData)
    : null
}

export { CustomLocaleToggleButton }
